import { render, staticRenderFns } from "./MenuAddForm.vue?vue&type=template&id=6d94302d&lang=html&"
import script from "./MenuAddForm.vue?vue&type=script&lang=js&"
export * from "./MenuAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports